(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProfessionDialogController', ProfessionDialogController);

    ProfessionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Profession'];

    function ProfessionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Profession) {
        var vm = this;
        vm.profession = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:professionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.profession.id !== null) {
                Profession.update(vm.profession, onSaveSuccess, onSaveError);
            } else {
                Profession.save(vm.profession, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
